/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PaymentCardType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.PaymentCardType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PaymentCardType_ {
   /// <summary>
   ///     ( )
   /// </summary>
   NotAccepted = 0,
   /// <summary>
   ///   MasterCard (MC)
   /// </summary>
   MasterCard = 1,
   /// <summary>
   ///   VISA (VISA)
   /// </summary>
   VISA = 2,
   /// <summary>
   ///   American Express (AMEX)
   /// </summary>
   Amex = 4,
   /// <summary>
   ///   Diners Club (DC)
   /// </summary>
   DinersClub = 8,
   /// <summary>
   ///   enRoute (ENRT)
   /// </summary>
   enRoute = 16,
   /// <summary>
   ///   Discover (DISC)
   /// </summary>
   Discover = 32,
   /// <summary>
   ///   JCB (JCB)
   /// </summary>
   JCB = 64,
   /// <summary>
   ///   Unknown (?)
   /// </summary>
   Unknown = 128
}

export const PaymentCardTypes: PaymentCardType[] = [
   {
      code: PaymentCardType_.NotAccepted,
      literal: 'NotAccepted',
      description: ' ',
      shortDescription: ' ',
      listPriority: 0,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.MasterCard,
      literal: 'MasterCard',
      description: 'MasterCard',
      shortDescription: 'MC',
      listPriority: 1,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.VISA,
      literal: 'VISA',
      description: 'VISA',
      shortDescription: 'VISA',
      listPriority: 0,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.Amex,
      literal: 'Amex',
      description: 'American Express',
      shortDescription: 'AMEX',
      listPriority: 2,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.DinersClub,
      literal: 'DinersClub',
      description: 'Diners Club',
      shortDescription: 'DC',
      listPriority: 0,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.enRoute,
      literal: 'enRoute',
      description: 'enRoute',
      shortDescription: 'ENRT',
      listPriority: 0,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.Discover,
      literal: 'Discover',
      description: 'Discover',
      shortDescription: 'DISC',
      listPriority: 3,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.JCB,
      literal: 'JCB',
      description: 'JCB',
      shortDescription: 'JCB',
      listPriority: 0,

      typeName: "PaymentCardType"
   },
   {
      code: PaymentCardType_.Unknown,
      literal: 'Unknown',
      description: 'Unknown',
      shortDescription: '?',
      listPriority: 0,

      typeName: "PaymentCardType"
   }
]

export class PaymentCardType implements IDomainModel {
   code: PaymentCardType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PaymentCardType_): PaymentCardType {
      return PaymentCardTypes.find(d => d.code === code)
   }
}
